
export const env ={
    NODE_ENV : "production"
} 